$(document).ready(function () {
  $(document).on('click','.yotpo-medium',function(event){
    event.preventDefault();
    $('html, body').animate({
        scrollTop: $(".yotpo_main_widget").offset().top - 100
    }, 2000);
  });
  /* product subscription selection module starts */
  $(document).on('click','.subscription_inner',function(){
    var type = $(this).data('type');
    if(type == 'subsave'){
      $(this).addClass('active');
      //$('#'+type).addClass('active');
      $('.ontime_subscription').removeClass('active');
      $('#product_selling_plan').attr('disabled', false);
    }else{
      $(this).addClass('active');
      $('.subscriptions').removeClass('active');
      $('#product_selling_plan').attr('disabled', true);
    }
  });
  
  $(document).on('click','.selling_plan',function(){
    var selling_price = $(this).data('price');
    $('.subscriptions .option__price').text(selling_price);
    $('.selling_plan').removeClass('active');
    $(this).addClass('active');
    var selling_plan_id = $(this).find('.selling_plan_id').val();
    $('#product_selling_plan').val(selling_plan_id);
  });
  
  /* product subscription selection module End */
  
  var $slider = $(".custom_main_megamenu .right_side_contain");

  if ($slider.length) {
    var currentSlide;
    var slidesCount;
    var sliderCounter = document.createElement('div');
    sliderCounter.classList.add('slider__counter');
    
    var updateSliderCounter = function(slick, currentIndex) {
      currentSlide = slick.slickCurrentSlide();
      if(currentSlide == 0){
        currentSlide = currentSlide + 1
      }else if(currentSlide > 2){
        currentSlide = currentSlide - 1
      }
      //console.log(slick);
      slidesCount = slick.slideCount / 2;
      slidesCount = Math.round(slidesCount);
      $(sliderCounter).html('Page <b>'+currentSlide+'</b>' + '/' +slidesCount)
    };
  
    $slider.on('init', function(event, slick) {
      $slider.append(sliderCounter);
      updateSliderCounter(slick);
    });
  
    $slider.on('afterChange', function(event, slick, currentSlide) {
      updateSliderCounter(slick, currentSlide);
    });
  }
  $(document).on('click','.select-label', function () {
      if($(this).parent().hasClass('active')){
        $(this).parent().removeClass('active');
      }else{
        $('.dropdown').removeClass('active');
        $(this).parent().addClass('active');
      }
  });
  $(document).on('click','.dropdown-list li', function () {
      $(this).parents('.dropdown').find('.select-label_inner').text($(this).text());
      $(this).parents('.dropdown').removeClass('active');
      var variant_id = $(this).data('value');
      $(this).parents('.main_variant_div').parent().find('.product-variant-id').val(variant_id);
  });
  
  $('.marquee-left').marquee({
    direction: 'left',
    duration: 30000,
    delayBeforeStart: 0,
    duplicated: true,
    gap: 0,
    startVisible: true
  });

  
  $('.banner_product_slider').marquee({
    direction: 'left',
    duration: 50000,
    delayBeforeStart: 0,
    duplicated: true,
    pauseOnHover: true,
    gap: 0,
    startVisible: true
  });
  // if($(window).width() > 991){
  //   $(".image-length").slick({
  //     autoplay: false,
  //     dots: true,
  //     arrows: true,
  //     infinite: true,
  //     slidesToShow: 1,
  //     slidesToScroll: 1
  //   });
  // }
  $(".new_product_inner").slick({
    pauseOnHover: false,
    autoplay: false,
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $(".review_list").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    arrows: false,
    asNavFor: ".product_list"
  });
  $(".product_list").slick({
    slidesToShow: 1,
    arrows: true,
    dots: true,
    slidesToScroll: 1,
    asNavFor: ".review_list",
    focusOnSelect: true
  });

  $(".service_inner").slick({
    vertical: true,
    verticalSwiping: true,
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplaySpeed: 0,
    speed: 3000,
    cssEase: "linear",
    centerMode: true
  });

  $(".blog_sc .blog__posts_custom").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  // contact page review
  
  $(".contact_review_inner").slick({
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $('.mobile_products .mobile-slider').slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    centerMode: true,
    centerPadding: '40px',
    slidesToShow: 1
  });
  const reco_pro = setInterval(recommodation_pro, 10);
  function recommodation_pro() {
    if($('.related-products').hasClass('product-recommendations--loaded')){
      $('.related-products .product-grid').slick({
        dots: false,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 2000,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
           {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              centerMode: true,
              centerPadding: '40px'
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '30px'
            }
          }
        ]
      });
    clearInterval(reco_pro);
    }
  }
  $(document).on('click','.accordion details',function(e) {
    e.preventDefault();
    if($(this).attr('open')){
     $(this).attr('open', false); 
    }else{
      $('.accordion details').attr('open', false);
      $(this).attr('open', true); 
    }
  });

  /* From our customers section link redirect to review pdp page start*/
  function reviewLink(){
    var pdp_link = $(".review_content .slick-active .prod__link").attr("href");
    var pdp_review_link = pdp_link + "#shopify-block-yotpo_product_reviews_ugc_reviews_6cBUpX";
    $(".all_review_button .link_button").attr("href", pdp_review_link);
     
  }
  reviewLink();
  $(document).on("click", ".review_content .slick-next, .review_content .slick-prev", function(){
    reviewLink();
  });
  $(document).on('swipe', '.review_content .product_list', function() {
    reviewLink();
  });
  /* From our customers section link redirect to review pdp page end*/

  /* The subscription options on product pages default to "Every 2 months", Change this to "Every 1 month.*/
    $('.selling_plan_title').each(function() {
        if ($(this).text().includes("Deliver every 1")) {
            $(this).closest('.selling_plan').click();
        }
    });
  /* The subscription options on product pages default to "Every 2 months", Change this to "Every 1 month */
   $('.related-products .product-grid-metafield').slick({
    dots: false,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 2000,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
       {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          centerMode: true,
          centerPadding: '40px'
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '30px'
        }
      }
    ]
  }); 
  
});




